<template>
    <div>
        <HeaderLogado></HeaderLogado>
        <vue-headful title="Catálogo Digital | Editora do Brasil"
                     description="Catálogo Digital da Editora do Brasil" />
        <section class="banner-catalogo hidden-sm-and-down">
            <v-container>
                <v-row>
                    <v-col cols="5" class="catalogo-title">
                        <v-img src="@/assets/catalogo-digital.svg" />
                    </v-col>
                </v-row>
            </v-container>
        </section>
        <section>
            <v-row class="busca">
                <v-col cols="12">
                    <div class="d-flex justify-center">
                        <div class="campo-de-busca">
                            <div class="autosuggest-container">
                                <vue-autosuggest v-model="query"
                                                 :suggestions="filteredOptions"
                                                 @focus="focusMe"
                                                 @input="onInputChange"
                                                 @selected="onSelected"
                                                 :get-suggestion-value="getSuggestionValue"
                                                 :input-props="{id:'autosuggest__input', placeholder:'Digite o nome do livro'}">
                                    <div slot-scope="{suggestion}" style="display: flex; align-items: center;">
                                        <!-- <router-link :to="{name: 'flippingbook', query: { id: suggestion.item.arquivo }}" target="_blank">  </router-link> -->
                                        <img :style="{ display: 'flex', width: 'auto', maxWidth: '28px', height: 'auto', maxHeight: '28px', marginRight: '10px'}"
                                             :src="suggestion.item.imagem" />
                                        <div style="{ display: 'flex', color: 'navyblue'}">{{suggestion.item.titulo}}</div>
                                    </div>
                                </vue-autosuggest>
                                <v-btn @click="pesquisarNome()" icon class="mt-1">
                                    <v-icon href color="primary">search</v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-row>
            <v-container fluid class="pt-8 pb-16">
                <v-row class="hidden-md-and-up">
                    <v-col cols="12">
                        <v-btn class="btn-filtrar" text @click="sheet = !sheet">
                            <v-icon>filter_list</v-icon>Filtrar
                        </v-btn>
                    </v-col>
                </v-row>

                <v-bottom-sheet v-model="sheet" inset class="hidden-md-and-up">
                    <v-sheet class="text-center" style="overflow-y: auto">
                        <v-card width="100%" outlined class="filtro filtro-mobile">
                            <v-list-item class="title">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Filtros
                                        <v-btn icon class="btn-fechar-filtro" text @click="sheet = !sheet">
                                            <v-icon>close</v-icon>
                                        </v-btn>
                                    </v-list-item-title>
                                    <!-- <v-list-item-subtitle>
                                                        subtext
                                    </v-list-item-subtitle>-->
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-list-item>
                                <v-expansion-panels accordion v-model="panel" :multiple="multiple" :flat="flat">
                                    <!--<v-expansion-panel>
                                                      <v-expansion-panel-header>Lançamentos</v-expansion-panel-header>
                                                      <v-expansion-panel-content>
                                                        <v-row>
                                                          <v-checkbox input-value="true" label="Didático" value></v-checkbox>
                                                        </v-row>
                                                        <v-row>
                                                          <v-checkbox input-value="true" label="Literatura" value></v-checkbox>
                                                        </v-row>
                                                      </v-expansion-panel-content>
                                    </v-expansion-panel>-->
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>Segmento</v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row v-for="segmento in segmentos" :key="segmento">
                                                <v-checkbox @change="filterSegmento(segmento)"
                                                            :label="segmento"
                                                            :value="segmento"></v-checkbox>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>Componente Curricular</v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row v-for="disciplina in disciplinas" :key="disciplina">
                                                <v-checkbox @change="filterDisciplina(disciplina)"
                                                            :label="disciplina"
                                                            :value="disciplina"></v-checkbox>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>Ano</v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row v-for="ano in anos" :key="ano">
                                                <v-checkbox @change="filterAno(ano)" :label="ano" :value="ano"></v-checkbox>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>Coleção</v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row v-for="colecao in colecoes" :key="colecao">
                                                <v-checkbox @change="filterColecao(colecao)"
                                                            :label="colecao"
                                                            :value="colecao"></v-checkbox>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <!--<v-expansion-panel>
                                                          <v-expansion-panel-header>Autor</v-expansion-panel-header>
                                                          <v-expansion-panel-content>
                                                              <v-row v-for="autor in autores" :key="autor">
                                                                  <v-checkbox @change="filterAutor(autor)" :label="autor" :value="autor"></v-checkbox>
                                                              </v-row>
                                                          </v-expansion-panel-content>
                                    </v-expansion-panel>-->
                                </v-expansion-panels>
                            </v-list-item>
                        </v-card>
                    </v-sheet>
                </v-bottom-sheet>

                <v-card width="240" outlined class="filtro float-left hidden-sm-and-down">
                    <v-list-item class="title">
                        <v-list-item-content>
                            <v-list-item-title>Filtros</v-list-item-title>
                            <!-- <v-list-item-subtitle>
                                                subtext
                            </v-list-item-subtitle>-->
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                        <v-expansion-panels accordion v-model="panel" :multiple="multiple" :flat="flat">
                            <!-- <v-btn @click="limparFiltros()">Limpar Filtros</v-btn> -->
                            <v-expansion-panel>
                                <v-expansion-panel-header>Segmento</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row v-for="segmento in segmentos" :key="segmento">
                                        <v-checkbox @change="filterSegmento(segmento)"
                                                    :label="segmento"
                                                    :value="segmento"></v-checkbox>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                                <v-expansion-panel-header>Componente Curricular</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row v-for="disciplina in disciplinas" :key="disciplina">
                                        <v-checkbox @change="filterDisciplina(disciplina)"
                                                    :label="disciplina"
                                                    :value="disciplina"></v-checkbox>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                                <v-expansion-panel-header>Ano</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row v-for="ano in anos" :key="ano">
                                        <v-checkbox @change="filterAno(ano)" :label="ano" :value="ano"></v-checkbox>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                                <v-expansion-panel-header>Coleção</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row v-for="colecao in colecoes" :key="colecao">
                                        <v-checkbox @change="filterColecao(colecao)" :label="colecao" :value="colecao"></v-checkbox>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <!--<v-expansion-panel>
                                              <v-expansion-panel-header>Autor</v-expansion-panel-header>
                                              <v-expansion-panel-content>
                                                  <v-row v-for="autor in autores" :key="autor">
                                                      <v-checkbox @change="filterAutor(autor)" :label="autor" :value="autor"></v-checkbox>
                                                  </v-row>
                                              </v-expansion-panel-content>
                            </v-expansion-panel>-->
                        </v-expansion-panels>
                    </v-list-item>
                </v-card>

                <v-row class="grid" align="stretch">
                    <v-container fluid grid-list-md class="pt-0">
                        <v-layout row wrap>
                            <v-flex xs12 sm6 md4 lg3 v-for="card in cards" :key="card.title">
                                <v-hover v-slot:default="{ hover }">
                                    <!--<router-link
                                      :to="{name: 'flippingbook', query: { id: card.arquivo }}"
                                      target="_blank"
                                    >-->
                                    <a v-on:click="abrirFlipbook(card.arquivo, card.isbn, card.complemento)">
                                        <v-card height="100%"
                                                :elevation="hover ? 12 : 2"
                                                :class="{ 'on-hover': hover }"
                                                outlined
                                                class="ml-1 mb-1 ml-sm-4 mb-sm-4 flex v-flex flex-column">
                                            <v-img :src="card.src" height="200px" class="ma-4"></v-img>
                                            <v-card-title v-text="card.title"></v-card-title>
                                            <v-card-text class="mb-4">
                                                <div class="text--primary" v-text="card.autor">Nome do Autor</div>
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-btn large block tile depressed>Visualizar</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </a>
                                    <!--</router-link>-->
                                </v-hover>
                            </v-flex>
                        </v-layout>
                        <p v-if="cards.length == 0">Não existe um livro com base nos filtros selecionados.</p>
                    </v-container>
                    <v-row>
                        <v-container>
                            <div class="text-xs-center">
                                <!-- <v-pagination v-model="page" :length="4" circle></v-pagination> -->
                            </div>
                        </v-container>
                    </v-row>
                </v-row>
            </v-container>
        </section>
    </div>
</template>

<script>
    import { VueAutosuggest } from "vue-autosuggest";
    import { generateTokenAPI, http } from "../services/APIservice";
    import HeaderLogado from "./HeaderLogado";
    export default {
        name: "Catalogo",
        components: {
            VueAutosuggest,
            HeaderLogado
        },
        data() {
            this.getLocal();
            this.getLivros();

            return {
                //filtros
                segmentos: [],
                segmentosAdicionados: [],
                anos: [],
                anosAdicionados: [],
                colecoes: [],
                colecoesAdicionadas: [],
                disciplinas: [],
                disciplinasAdicionadas: [],
                autores: [],
                autoresAdicionados: [],

                sheet: false, // Abre filtro no mobile
                page: 1, // paginação
                isActive: false, // Lazy content
                multiple: true, // Menu left
                flat: false,
                panel: [0, 1, 2, 3, 4, 5],
                right: null,
                cards: [],
                query: "", // Busca
                selected: "",
                suggestions: [
                    {
                        data: []
                    }
                ]
            };
        },
        watch: {
            selected: function (val) {
                if (val == "") {
                    return;
                }
                this.abrirFlipbook(val.arquivo, val.id, val.complemento);
            }
        },
        computed: {
            filteredOptions() {
                return [
                    {
                        data: this.suggestions[0].data.filter(option => {
                            return (
                                option.titulo.toLowerCase().indexOf(this.query.toLowerCase()) > -1
                            );
                        })
                    }
                ];
            }
        },
        methods: {
            getLocal() {
                try {
                    const storage = JSON.parse(localStorage.getItem("user"));
                    //this.Usuario = storage.usuario.nome
                    //this.Guid = storage.usuario.guid
                    this.$parent.$root.$children[0].userName = storage.userName.split(
                        " "
                    )[0];
                    this.token = storage.token;
                    this.livros = [];
                } catch (error) {
                    alert("Entre com seu usuário e senha para acessar o conteúdo.");
                    let self = this;
                    self.$router.push("/");
                    console.log(error);
                }
            },
            async getLivros() {
                //const storage = JSON.parse(localStorage.getItem('user'));
                await http
                    .get(`Flipbook/GetAll?userGuid=${this.token}`, {
                        headers: {
                            "Access-Control-Allow-Origin": "*",
                            Authorization: "Bearer " + this.token
                        }
                    })
                    .then(res => {
                        //console.log(this.token);
                        this.livros = res.data;
                        this.livrosFilter = res.data;
                        this.setFiltros();
                        this.setLivros(this.livros);
                        this.setSuggestions();
                    })
                    .catch(err => {
                        console.log(err);
                        alert("Sua sessão expirou!");
                        this.$router.push("/");
                    });
            },
            async setLogFlipbook(isbn, complemento) {
                http.put("Flipbook/LogAcessoFlipbook", { isbn: isbn, complemento: complemento }, {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Authorization": "Bearer " + this.token
                    }
                })

                return
            },
            // async verificarFlip(guid, token) {
            //     generateTokenAPI.get("GenerateGuid/Search?guid="+guid,
            //     {
            //         headers: {
            //             "Access-Control-Allow-Origin": "*",
            //             "Authorization": "Bearer " + token
            //         }
            //     })
            //     .then(res => {
            //         console.log(res.data.statusDescription);
            //     })
            //     .catch(err => {
            //         console.log(err);
            //         alert("Sua sessão expirou!");
            //         this.$router.push("/");
            //     });
            // },
            setSuggestions() {
                let suggestions = [];

                this.livros.forEach(function (livro) {
                    suggestions.push({
                        id: livro.isbn,
                        titulo: livro.nome,
                        seguimento: livro.segmento,
                        imagem: livro.capaURL,
                        arquivo: livro.flipbookURL,    
                        complemento: livro.complemento,
                    });
                });

                this.suggestions[0].data = suggestions;
            },
            setLivros(livros) {
                let cards = [];
                livros.sort((a, b) => {
                    return a.nome.localeCompare(b.nome);
                });

                livros.forEach(function (livro) {
                    cards.push({
                        isbn: livro.isbn,
                        title: livro.nome,
                        src: livro.capaURL,
                        flex: 3,
                        arquivo: livro.flipbookURL,
                        autor: livro.autor,
                        complemento : livro.complemento
                    });
                });

                this.cards = cards;
            },
            setFiltros() {
                let filtros = {
                    autores: [],
                    segmentos: [],
                    disciplinas: [],
                    anos: [],
                    colecoes: []
                };
                this.livros.forEach(function (livro) {
                    if (!filtros.autores.includes(livro.autor)) {
                        filtros.autores.push(livro.autor);
                    }
                    if (!filtros.segmentos.includes(livro.segmento)) {
                        filtros.segmentos.push(livro.segmento);
                    }
                    if (!filtros.disciplinas.includes(livro.materia)) {
                        filtros.disciplinas.push(livro.materia);
                    }
                    if (!filtros.anos.includes(livro.ano)) {
                        filtros.anos.push(livro.ano);
                    }
                    if (!filtros.colecoes.includes(livro.colecao)) {
                        filtros.colecoes.push(livro.colecao);
                    }
                });

                this.anos = filtros.anos.sort();
                this.autores = filtros.autores.sort();
                this.colecoes = filtros.colecoes.sort();
                this.disciplinas = filtros.disciplinas.sort();
                this.segmentos = filtros.segmentos.sort();
                //this.filtros = filtros;
            },
            async abrirFlipbook(url, isbn, complemento) {
                //CHAMAR API DE ACCESSTOKEN DO FLIPBOOK
                console.log(localStorage.getItem("GT"));
                const storageGT = JSON.parse(localStorage.getItem("GT"));
                this.gtToken = storageGT.token;
                this.gtCodUser = storageGT.user_id;
                console.log(url);
                //console.log(this.gtCodUser);
                //console.log(this.gtToken);

                generateTokenAPI.post(`GenerateGuid/Create`, 
                {user_Id: this.gtCodUser},
                { headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Authorization": "Bearer " + this.gtToken
                    },                 
                })
                .then(res => {
                    //console.log(res);
                    let params = `?guid=${res.data.guid}&token=${this.gtToken}`;

                    let routeData = this.$router.resolve({
                        name: "flippingbook",
                        query: { id: url+params }
                    });
                    
                    //console.log(params);
                    
                    window.open(routeData.href, "_blank");
                    this.setLogFlipbook(isbn, complemento);
                    //this.verificarFlip(res.data.guid, this.gtToken);
                })
                .catch(err => {
                    console.log(err);
                    alert("Sua sessão expirou!");
                    this.$router.push("/");
                });
            },
            setFilter(isbn, complemento) {
                let livro = this.livros.filter(livro => livro.isbn == isbn && livro.complemento == complemento);
                this.setLivros(livro);
            },
            filterSegmento(value) {
                if (this.segmentosAdicionados.includes(value)) {
                    this.segmentosAdicionados.splice(
                        this.segmentosAdicionados.indexOf(value),
                        1
                    );
                    this.filterMaster();
                    return;
                }
                this.segmentosAdicionados.push(value);
                this.filterMaster();
            },
            filterAno(value) {
                if (this.anosAdicionados.includes(value)) {
                    this.anosAdicionados.splice(this.anosAdicionados.indexOf(value), 1);
                    this.filterMaster();
                    return;
                }
                this.anosAdicionados.push(value);

                this.filterMaster();
            },
            filterDisciplina(value) {
                if (this.disciplinasAdicionadas.includes(value)) {
                    this.disciplinasAdicionadas.splice(
                        this.disciplinasAdicionadas.indexOf(value),
                        1
                    );
                    this.filterMaster();
                    return;
                }
                this.disciplinasAdicionadas.push(value);

                this.filterMaster();
            },
            filterColecao(value) {
                if (this.colecoesAdicionadas.includes(value)) {
                    this.colecoesAdicionadas.splice(
                        this.colecoesAdicionadas.indexOf(value),
                        1
                    );
                    this.filterMaster();
                    return;
                }
                this.colecoesAdicionadas.push(value);
                this.filterMaster();
            },
            filterAutor(value) {
                if (this.autoresAdicionados.includes(value)) {
                    this.autoresAdicionados.splice(
                        this.autoresAdicionados.indexOf(value),
                        1
                    );
                    this.filterMaster();
                    return;
                }
                this.autoresAdicionados.push(value);
                this.filterMaster();
            },
            filterMaster() {
                let livros = this.livros;
                if (this.disciplinasAdicionadas.length > 0) {
                    livros = livros.filter(livro =>
                        this.disciplinasAdicionadas.includes(livro.materia)
                    );
                }
                if (this.anosAdicionados.length > 0) {
                    livros = livros.filter(livro =>
                        this.anosAdicionados.includes(livro.ano)
                    );
                }
                if (this.segmentosAdicionados.length > 0) {
                    livros = livros.filter(livro =>
                        this.segmentosAdicionados.includes(livro.segmento)
                    );
                }
                if (this.colecoesAdicionadas.length > 0) {
                    livros = livros.filter(livro =>
                        this.colecoesAdicionadas.includes(livro.colecao)
                    );
                }
                if (this.autoresAdicionados.length > 0) {
                    livros = livros.filter(livro =>
                        this.autoresAdicionados.includes(livro.autor)
                    );
                }


                //if(livros.length == 0){ alert('Infelizmente não existe um livro com base nos filtros selecionados')}

                this.setLivros(livros);
            },
            pesquisarNome() {
                let value = this.query;
                let livros = this.livros.filter(function (livro) {
                    return livro.nome.toUpperCase().includes(value.toUpperCase());
                });
                this.setLivros(livros);
            },
            limparFiltros() {
                this.setFilter();
            },
            onSelected(item) {
                this.selected = item.item;
            },
            onInputChange() {
                // event fired when the input changes
            },
            /**
             * This is what the <input/> value is set to when you are selecting a suggestion.
             */
            getSuggestionValue(suggestion) {

                return suggestion.item.name;
            },
            focusMe() {
                // FocusEvent
            }
        }
        // created() {
        //     this.getStorageGT()
        // }
    };
</script>

<style lang="scss">
@import "../css/style.scss";

section.banner-catalogo {
  background-image: url("../assets/bg-catalogo.png");
  /* Full height */
  height: 100vh;
  max-height: 486px;
  //height: 100%;
  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  @media only screen and (max-width: 600px) {
    max-height: 286px;
  }
}

.catalogo-title {
  margin-top: 140px;
  max-width: 470px;
}

.parte {
  background: rgba(25, 40, 110, 0.7) !important;
  color: white !important;
  width: auto !important;
  display: initial !important;
  margin-top: 24px;
  font-size: 48px;
  font-weight: bolder;
}

.busca {
  background: #19286e;

  @media only screen and (max-width: 959.99px) {
    margin: 104px 0 0 0;
    background: none !important;
  }

  .campo-de-busca {
    background: white;
    width: 100%;
    max-width: 500px;
    margin: 0 24px;

    @media only screen and (max-width: 959.99px) {
      max-width: auto;
      margin: 0;
      border: 1px solid #19286e;
    }
  }

  input {
    width: 100%;
    padding: 0.5rem;
    border: 0 !important;
  }

  ul {
    width: 100%;
    color: rgba(30, 39, 46, 1);
    list-style: none;
    margin: 0;
    padding: 0.5rem 0 0.5rem 0;
  }

  li {
    margin: 0 0 0 0;
    padding: 0.75rem 0 0.75rem 0.75rem;
    display: flex;
    align-items: center;
  }

  li:hover {
    cursor: pointer;
  }

  .autosuggest-container {
    display: flex;
    justify-content: center;
  }

  :focus {
    outline: -webkit-focus-ring-color auto 0 !important;
    //remove borda do input qdo tem focus
  }

  #autosuggest {
    width: 100%;
    display: block;
  }

  .autosuggest__results-item--highlighted {
    background-color: #efefef;
  }

  .autosuggest__results-container {
    background: white;
    width: 100%;
    max-width: 500px;
    max-height: 400px;
    overflow-x: auto;
    position: absolute;
    z-index: 9;
    -webkit-box-shadow: 0px 3px 5px 0px rgba(105, 21, 21, 0.3);
    -moz-box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 3px 5px 0px rgba(3, 2, 2, 0.3);
  }
}

.filtro {
  &.v-card {
    border-radius: 0;
  }

  .title {
    background: #eee;
  }

  .v-list-item__title {
    padding: 8px 16px;
    color: #19286e;
  }

  .v-expansion-panel::before {
    box-shadow: none;
  }

  .v-expansion-panel-header {
    min-height: initial;
    padding: 16px;
    color: #19286e;
  }

  .v-list-item {
    padding: 0;
  }

  .v-input--selection-controls {
    margin-top: 0;
    padding-top: 4px;
  }

  .v-label {
    font-size: 13px;
  }

  .v-messages {
    display: none;
  }
  &.filtro-mobile {
    height: 95vh;
    .v-item-group {
      overflow-x: auto !important;
      height: calc(95vh - 76px);
      padding-bottom: 16px;
    }
  }
}

.btn-filtrar {
  &.v-btn,
  .v-icon {
    color: #19286e;
  }
}

.btn-fechar-filtro {
  position: absolute;
  top: 12px;
  right: 16px;
}

.grid {
  & > .col,
  & > [class*="col-"] {
    padding: 0 !important;
  }

  .flex {
    padding: 0 0 16px 0 !important;
  }

  .v-image__image--cover {
    background-size: contain;
  }

  a {
    text-decoration: none;
  }

  .v-card {
    border-radius: 0;
    .v-card__title {
      color: #19286e;
      align-items: left;
      font-size: 1rem;
      font-weight: 600;
      letter-spacing: 0.0125em;
      line-height: 1.2rem;
      padding: 8px 16px 8px 16px;
      word-break: initial;
    }

    .v-card__actions {
      width: 100%;
      padding: 0;
      position: absolute;
      bottom: 0;
    }

    .v-btn {
      background-color: #93c83d !important;
      color: #19286e;
    }

    &.elevation-2 {
      box-shadow: none !important;
    }
  }

  .v-pagination__item,
  .v-pagination__navigation {
    box-shadow: none;
  }

  .v-pagination__item:focus,
  .v-pagination__navigation:focus {
    outline: -webkit-focus-ring-color auto 0;
  }

  .layout:only-child {
    margin: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
</style>
